import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react'
import Home from './Home';

import RegisterPage from './pages/registerPage/RegisterPage';
import LoginPage from './pages/loginPage/LoginPage';
import { AuthProvider } from './context/authContext';
import Layout from './pages/layout/Layout';
import Movie from './pages/moviePage/Movie';
import UploadPage from './pages/uploadPage/UploadPage';
import SelfieVideosPage from './pages/selfieVideosPage/SelfieVideosPage';
import VideoPage from './pages/videoPage/VideoPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import VerifyPage from './pages/verifyPage/verifyPage';
import ForgotPasswordPage from './pages/forgotPasswordPage/ForgotPasswordPage';
import ResetPasswordPage from './pages/resetPasswordPage/ResetPasswordPage';
import RequestVerifyPage from './pages/requestVerifyPage/RequestVerifyPage';
import EditVideoPage from './pages/editVideoPage/EditVideoPage';
import EditProfilePage from './pages/editProfilePage/EditProfilePage';



const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes >
          <Route path="/" element={<Layout />} >
            <Route index element={<Home />} />
            <Route path="/movie/:id" element={<Movie />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/upload-movie" element={<UploadPage />} />
            <Route path="/profile/:id" element={<ProfilePage />} />
            <Route path="/profile/edit/:id" element={<EditProfilePage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/request-verification" element={<RequestVerifyPage />} />
            <Route path="/selfieVideos" element={<SelfieVideosPage />} />
            <Route path="/selfieVideos/:id" element={<VideoPage />} />
            <Route path="/selfieVideos/edit/:id/" element={<EditVideoPage />} />"
          </Route>
          <Route path="/verify" element={<VerifyPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App